export interface FormData {
  firstName: string,
  lastName: string,
  country: string,
  postalCode: number | string,
}

export function createEmptyFormData(): FormData {
  return {
    firstName: '',
    lastName: '',
    country: '',
    postalCode: '',
  };
}

export interface PaymentFormState {
  firstName: null | string,
  lastName: null | string,
  number: null | string,
  month: null | string,
  year: null | string,
  cvv: null | string,
  postalCode: null | string,
  country: null | string,
}

export function createEmptyPaymentFormState(): PaymentFormState {
  return {
    firstName: null,
    lastName: null,
    number: null,
    month: null,
    year: null,
    cvv: null,
    postalCode: null,
    country: null,
  };
}
